import {AfterContentInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {GetSetDataService} from '../../services/get-set-data.service';
import {PowerbiContentComponent} from '../powerbi-content/powerbi-content.component';
import {SearchPipe} from '../pipes/search-pipe.pipe';
import {FullSortPipe} from '../pipes/fullSort.pipe';
import {JsonPipe, NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {HighlightPipe} from '../pipes/highlight.pipe';
import {ChartViewComponent} from '../../chart-view/chart-view.component';



@Component({
  selector: 'app-single-report-small',
  templateUrl: './single-report-small.component.html',
  imports: [
    PowerbiContentComponent,
    SearchPipe,
    FullSortPipe,
    NgForOf,
    NgStyle,
    NgClass,
    HighlightPipe,
    NgIf,
    ChartViewComponent
  ],
  styleUrls: ['./single-report-small.component.scss']
})
export class SingleReportSmallComponent implements OnInit, AfterContentInit {

  @Input() allData: any;
  @Input() charts: any;
  @Input() powerbiData: any;
  @Input() filterType = '';
  @Input() reverseArray = false;
  @Input() showEmptyIcon = true;
  @Input() showFavoriteIconCompletely = true;

  @ViewChild('reportSmallView') reportSmallView?: ElementRef;

  public searchQuery: string = '';
  private subscriptionSearch?: Subscription;

  constructor(private getSetData: GetSetDataService, private router: Router) {
  }

  ngOnInit() {
    this.subscriptionSearch = this.getSetData.EmitterSearch.subscribe((searchQuery: string) => {
      this.searchQuery = searchQuery;
    });
  }

  ngAfterContentInit() {
    this.getSetData.EmitterDataFetched.next(true);
  }

  /**
   * Gets the report id and if it's already favorited, and adds/removes the report from database.
   * @param reportID
   * @param isReportAlredyFavorite
   */
  public async toggleFavoriteReport(reportID: string, isReportAlredyFavorite: boolean) {
    if (isReportAlredyFavorite) {
      await this.getSetData.removeFavoriteReport(reportID);
      this.router.navigateByUrl('/reload');
    } else {
      await this.getSetData.setFavoriteReport(reportID);
      this.router.navigateByUrl('/reload');
    }
  }

  /**
   * Returns normalized array of category/department label strings from whatever field the API provides.
   * Handles both string[] and {name|category_name}[] shapes.
   */
  public getReportCategories(data: any): string[] {
    const raw = data.report_categories ?? data.post_categories ?? data.report_departments ?? [];
    if (!Array.isArray(raw) || raw.length === 0) return [];
    return raw.map((c: any) => (typeof c === 'string' ? c : c.name ?? c.category_name ?? '')).filter(Boolean);
  }

  public getSystemInfo(reportTypes: string[]): { bg: string; color: string; icon: string; label: string; cssClass: string } {
    const type = reportTypes && reportTypes.length > 0 ? reportTypes[0] : '';
    switch (type) {
      case 'PowerBI':
        return { bg: '#eaf3de', color: '#3b6d11', icon: 'ti-chart-bar', label: 'Power BI', cssClass: 'pbi' };
      case 'Tableau':
        return { bg: '#faeeda', color: '#854f0b', icon: 'ti-chart-dots-3', label: 'Tableau', cssClass: 'tableau' };
      case 'Excel':
        return { bg: '#e8f5ee', color: '#1a6b3a', icon: 'ti-table', label: 'Excel', cssClass: 'excel' };
      case 'Workday':
        return { bg: '#EEEDFE', color: '#534AB7', icon: 'ti-building', label: 'Workday', cssClass: 'workday' };
      default:
        return { bg: '#e8f0fb', color: '#185fa5', icon: 'ti-file-text', label: 'Banner', cssClass: 'banner' };
    }
  }

  public async updateReportCounters(postID: number) {
    await this.getSetData.updateReportCountersByAll(postID);
    await this.getSetData.updateReportCountersByUser(postID);
  }

  /**
   * Used to like the report.
   * @param postID
   * @param event
   * @param report
   */
  public async likeReport(postID: number, event: any, report: any) {
    const element = event;

    const elementLikes = report.getElementsByClassName('js-report-likes')[0];
    let reportLikes = parseInt(elementLikes.innerHTML, 0);

    if (element.className.indexOf('report-rated') === -1) {
      await this.getSetData.updateReportLikes(postID);
      reportLikes = reportLikes + 1;
      elementLikes.innerHTML = reportLikes;
      element.classList.add('report-rated');
    }
  }
}
